import SnackbarContentWrapper from './SnackbarContentWrapper';

export default SnackbarContentWrapper;